import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowBack = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.50464 9H16.4953",
		stroke: "#D9DEEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.49528 1.66663L1.73328 8.49929C1.66234 8.56185 1.60553 8.63879 1.56661 8.725C1.52769 8.81121 1.50757 8.90471 1.50757 8.99929C1.50757 9.09388 1.52769 9.18738 1.56661 9.27358C1.60553 9.35979 1.66234 9.43673 1.73328 9.49929L9.49528 16.3333",
		stroke: "#D9DEEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgArrowBack);
export default ForwardRef;
